export enum PensionPaymentTypeEnum {
    Nominated = 1,
    Minimum = 2,
    Maximum = 3,
    NominatedPlusCPI = 4,
    AnnualisedMinimum = 5,
}